module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 339,
	"w": 429,
	"h": 400,
	"nm": "Flying_box",
	"ddd": 1,
	"assets": [
		{
			"id": "comp_0",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 0,
					"nm": "box m vingar 2",
					"refId": "comp_1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"t": 2,
									"s": [
										300,
										300,
										0
									],
									"to": [
										0,
										-3,
										0
									],
									"ti": [
										0,
										0,
										0
									]
								},
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"t": 8,
									"s": [
										300,
										282,
										0
									],
									"to": [
										0,
										0,
										0
									],
									"ti": [
										0,
										-0.473,
										0
									]
								},
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"t": 15,
									"s": [
										300,
										286,
										0
									],
									"to": [
										0,
										0.369,
										0
									],
									"ti": [
										0,
										-0.32,
										0
									]
								},
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"t": 23,
									"s": [
										300,
										265.03,
										0
									],
									"to": [
										0,
										0.415,
										0
									],
									"ti": [
										0,
										-1.553,
										0
									]
								},
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"t": 31,
									"s": [
										300,
										269,
										0
									],
									"to": [
										0,
										1.261,
										0
									],
									"ti": [
										0,
										-1.95,
										0
									]
								},
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"t": 40,
									"s": [
										300,
										251,
										0
									],
									"to": [
										0,
										2.78,
										0
									],
									"ti": [
										0,
										-0.326,
										0
									]
								},
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"t": 50,
									"s": [
										300,
										256,
										0
									],
									"to": [
										0,
										0.791,
										0
									],
									"ti": [
										0,
										-3.758,
										0
									]
								},
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"t": 92,
									"s": [
										300,
										287.331,
										0
									],
									"to": [
										0,
										2.575,
										0
									],
									"ti": [
										0,
										0,
										0
									]
								},
								{
									"t": 113,
									"s": [
										300,
										300,
										0
									]
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								300,
								300,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"w": 600,
					"h": 600,
					"ip": 0,
					"op": 113,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_1",
			"layers": [
				{
					"ddd": 1,
					"ind": 1,
					"ty": 4,
					"nm": "framvinge/flygande-paket Outlines",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"rx": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 0,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 8,
									"s": [
										114
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 16,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 23,
									"s": [
										114
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 31,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.636
										],
										"y": [
											0.464
										]
									},
									"o": {
										"x": [
											0.356
										],
										"y": [
											0.006
										]
									},
									"t": 38,
									"s": [
										114
									]
								},
								{
									"i": {
										"x": [
											0.609
										],
										"y": [
											1.028
										]
									},
									"o": {
										"x": [
											0.226
										],
										"y": [
											0.455
										]
									},
									"t": 52,
									"s": [
										91.728
									]
								},
								{
									"i": {
										"x": [
											0.774
										],
										"y": [
											-1.295
										]
									},
									"o": {
										"x": [
											0.347
										],
										"y": [
											-0.09
										]
									},
									"t": 72,
									"s": [
										68.776
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.318
										],
										"y": [
											0.242
										]
									},
									"t": 100,
									"s": [
										57.906
									]
								},
								{
									"t": 114,
									"s": [
										0
									]
								}
							]
						},
						"ry": {
							"a": 0,
							"k": 0
						},
						"rz": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 0,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 8,
									"s": [
										-21
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 16,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 23,
									"s": [
										-21
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 31,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1.79
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 38,
									"s": [
										-21
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											0.68
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0.117
										]
									},
									"t": 77,
									"s": [
										-30.025
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											1.228
										]
									},
									"t": 90,
									"s": [
										-9.751
									]
								},
								{
									"t": 114,
									"s": [
										0
									]
								}
							]
						},
						"or": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"p": {
							"a": 0,
							"k": [
								242,
								344,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								26.062,
								39.336,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 0,
									"s": [
										334.472,
										334.472,
										334.472
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 8,
									"s": [
										334.472,
										334.472,
										334.472
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 16,
									"s": [
										334.472,
										334.472,
										334.472
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 23,
									"s": [
										334.472,
										334.472,
										334.472
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 31,
									"s": [
										334.472,
										334.472,
										334.472
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 38,
									"s": [
										334.472,
										334.472,
										334.472
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 52,
									"s": [
										334.472,
										334.472,
										334.472
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 76,
									"s": [
										334.472,
										334.472,
										334.472
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 90,
									"s": [
										334.472,
										334.472,
										334.472
									]
								},
								{
									"t": 114,
									"s": [
										334.472,
										334.472,
										334.472
									]
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-5.996,
													-3.044
												],
												[
													5.996,
													3.044
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"bm": 0,
									"nm": "Stroke 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											9.423,
											18.332
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.557,
													-3.27
												],
												[
													6.557,
													3.27
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"bm": 0,
									"nm": "Stroke 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											8.766,
											11.548
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-2.34,
													-1.161
												],
												[
													0,
													0
												],
												[
													-0.001,
													-1.23
												],
												[
													0,
													0
												],
												[
													-1.3,
													-0.695
												],
												[
													-0.5,
													0
												],
												[
													0,
													1.696
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													3.994,
													1.996
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0.426,
													2.474
												],
												[
													0,
													0
												],
												[
													1.148,
													0.57
												],
												[
													0,
													0
												],
												[
													0.001,
													1.417
												],
												[
													0.486,
													0.26
												],
												[
													1.602,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-4.285
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-14.549,
													-19.864
												],
												[
													-11.329,
													-1.137
												],
												[
													-6.937,
													4.637
												],
												[
													6.007,
													11.057
												],
												[
													7.876,
													13.985
												],
												[
													7.876,
													16.067
												],
												[
													9.98,
													19.485
												],
												[
													11.48,
													19.864
												],
												[
													14.549,
													16.951
												],
												[
													14.549,
													15.295
												],
												[
													14.549,
													6.336
												],
												[
													14.549,
													1.643
												],
												[
													8.055,
													-8.57
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-3.917
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.995,
													0
												],
												[
													0.323,
													0.173
												],
												[
													0.001,
													1.045
												],
												[
													0,
													0
												],
												[
													1.495,
													0.742
												],
												[
													0,
													0
												],
												[
													0.369,
													2.147
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													3.665,
													1.831
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													1.182
												],
												[
													-0.359,
													0
												],
												[
													-0.972,
													-0.52
												],
												[
													0,
													0
												],
												[
													-0.001,
													-1.617
												],
												[
													0,
													0
												],
												[
													-2.043,
													-1.013
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-13.229,
													-18.086
												],
												[
													7.607,
													-7.675
												],
												[
													13.549,
													1.643
												],
												[
													13.549,
													6.336
												],
												[
													13.549,
													15.295
												],
												[
													13.549,
													16.951
												],
												[
													11.48,
													18.864
												],
												[
													10.452,
													18.604
												],
												[
													8.876,
													16.067
												],
												[
													8.876,
													13.985
												],
												[
													6.451,
													10.161
												],
												[
													-6.492,
													3.741
												],
												[
													-10.344,
													-1.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											14.798,
											20.114
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.661,
													0
												],
												[
													0.397,
													0.212
												],
												[
													0.001,
													1.229
												],
												[
													0,
													0
												],
												[
													1.323,
													0.656
												],
												[
													0,
													0
												],
												[
													0.396,
													2.304
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-4.107
												],
												[
													0,
													0
												],
												[
													0.496,
													-0.453
												]
											],
											"o": [
												[
													-0.442,
													0
												],
												[
													-1.134,
													-0.607
												],
												[
													0,
													0
												],
												[
													-0.001,
													-1.426
												],
												[
													0,
													0
												],
												[
													-2.185,
													-1.085
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													3.835,
													1.916
												],
												[
													0,
													0
												],
												[
													0,
													0.659
												],
												[
													-0.482,
													0.438
												]
											],
											"v": [
												[
													11.4,
													19.17
												],
												[
													10.135,
													18.85
												],
												[
													8.296,
													15.873
												],
												[
													8.296,
													13.791
												],
												[
													6.148,
													10.415
												],
												[
													-6.794,
													3.995
												],
												[
													-10.917,
													-1.416
												],
												[
													-13.969,
													-19.17
												],
												[
													7.751,
													-8.317
												],
												[
													13.969,
													1.448
												],
												[
													13.969,
													16.756
												],
												[
													13.199,
													18.48
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0.274509803922,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											14.879,
											20.309
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"bm": 0,
							"hd": false
						}
					],
					"ip": 0,
					"op": 300,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "box",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								290,
								329,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								108.5,
								107.5,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								322.107,
								322.107,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													1.211,
													4.998
												],
												[
													-1.21,
													4.998
												],
												[
													-1.21,
													-4.998
												],
												[
													1.211,
													-4.998
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0.274509803922,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											133.897,
											117.884
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													1.285,
													4.998
												],
												[
													-1.285,
													4.998
												],
												[
													-1.285,
													-4.998
												],
												[
													1.285,
													-4.998
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0.274509803922,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											124.686,
											121.748
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 8",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													2.263,
													-1.306
												],
												[
													0.116,
													-6.043
												],
												[
													-2.263,
													1.019
												],
												[
													-0.907,
													0.301
												],
												[
													-0.974,
													6.043
												],
												[
													1.237,
													4.816
												],
												[
													1.304,
													-0.773
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											119.91,
											122.558
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.115,
													-6.043
												],
												[
													-2.263,
													1.019
												],
												[
													-0.907,
													0.301
												],
												[
													-0.974,
													6.043
												],
												[
													1.238,
													4.816
												],
												[
													1.305,
													-0.773
												],
												[
													2.262,
													-1.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											114.887,
											125.166
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 10",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													5.057,
													-2.738
												],
												[
													-5.058,
													2.738
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"bm": 0,
									"nm": "Stroke 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											129.305,
											119.673
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-4.125,
													2.215
												],
												[
													4.125,
													-2.215
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"bm": 0,
									"nm": "Stroke 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											129.424,
											122.411
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 12",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-9.542,
													-8.847
												],
												[
													-16.695,
													-5.049
												],
												[
													9.595,
													8.847
												],
												[
													16.696,
													5.031
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"bm": 0,
									"nm": "Stroke 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											110.445,
											92.482
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 13",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-3.546,
													7.148
												],
												[
													0.552,
													1.362
												],
												[
													3.546,
													3.348
												],
												[
													3.546,
													-7.148
												],
												[
													-3.546,
													-3.348
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"bm": 0,
									"nm": "Stroke 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											123.811,
											104.7
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 14",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													109.368,
													107.122
												],
												[
													109.368,
													138.417
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"bm": 0,
									"nm": "Stroke 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 15",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-26.195,
													-6.884
												],
												[
													-0.264,
													7.062
												],
												[
													26.195,
													-7.062
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"bm": 0,
									"nm": "Stroke 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											109.632,
											100.06
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 16",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-29.714
												],
												[
													-26.46,
													-15.706
												],
												[
													-26.46,
													15.706
												],
												[
													0,
													29.714
												],
												[
													26.46,
													15.706
												],
												[
													26.46,
													-15.706
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"bm": 0,
									"nm": "Stroke 1",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0.274509803922,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											109.368,
											108.704
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 17",
							"bm": 0,
							"hd": false
						}
					],
					"ip": 0,
					"op": 300,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 1,
					"ind": 3,
					"ty": 4,
					"nm": "bakvinge/flygande-paket Outlines",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"rx": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 0,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 8,
									"s": [
										-114
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 16,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 23,
									"s": [
										-114
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 31,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.471
										],
										"y": [
											0.325
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 38,
									"s": [
										-114
									]
								},
								{
									"i": {
										"x": [
											0.591
										],
										"y": [
											0.773
										]
									},
									"o": {
										"x": [
											0.313
										],
										"y": [
											0.589
										]
									},
									"t": 53,
									"s": [
										-82.299
									]
								},
								{
									"i": {
										"x": [
											0.619
										],
										"y": [
											-2.014
										]
									},
									"o": {
										"x": [
											0.349
										],
										"y": [
											0.368
										]
									},
									"t": 73,
									"s": [
										-61.803
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0.232
										]
									},
									"t": 99,
									"s": [
										-58.525
									]
								},
								{
									"t": 114,
									"s": [
										0
									]
								}
							]
						},
						"ry": {
							"a": 0,
							"k": 0
						},
						"rz": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 0,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 8,
									"s": [
										-21
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 16,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 23,
									"s": [
										-21
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 31,
									"s": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											-24.955
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"t": 38,
									"s": [
										-21
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											0.364
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0.233
										]
									},
									"t": 76,
									"s": [
										-20.732
									]
								},
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0.512
										]
									},
									"t": 90,
									"s": [
										-9.751
									]
								},
								{
									"t": 100,
									"s": [
										0
									]
								}
							]
						},
						"or": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"p": {
							"a": 0,
							"k": [
								332,
								295,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								26.17,
								41.287,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 0,
									"s": [
										313.333,
										313.333,
										313.333
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 8,
									"s": [
										313.333,
										193.333,
										313.333
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 16,
									"s": [
										313.333,
										313.333,
										313.333
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 23,
									"s": [
										313.333,
										193.333,
										313.333
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 31,
									"s": [
										313.333,
										313.333,
										313.333
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 38,
									"s": [
										313.333,
										193.333,
										313.333
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 52,
									"s": [
										313.333,
										256.19,
										313.333
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 76,
									"s": [
										313.333,
										256.19,
										313.333
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"t": 90,
									"s": [
										313.333,
										256.19,
										313.333
									]
								},
								{
									"t": 114,
									"s": [
										313.333,
										313.333,
										313.333
									]
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-5.686,
													-3.04
												],
												[
													5.686,
													3.04
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"bm": 0,
									"nm": "Stroke 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											9.113,
											19.131
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.327,
													-3.323
												],
												[
													6.327,
													3.323
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"bm": 0,
									"nm": "Stroke 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											8.473,
											11.859
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"bm": 0,
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-2.34,
													-1.223
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-1.3,
													-0.732
												],
												[
													-0.5,
													0
												],
												[
													0,
													1.786
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													3.994,
													2.102
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0.426,
													2.606
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.001,
													1.492
												],
												[
													0.486,
													0.274
												],
												[
													1.602,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-4.513
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-14.549,
													-20.924
												],
												[
													-11.329,
													-1.198
												],
												[
													-6.937,
													4.884
												],
												[
													7.875,
													12.624
												],
												[
													7.876,
													16.924
												],
												[
													9.98,
													20.525
												],
												[
													11.48,
													20.924
												],
												[
													14.549,
													17.855
												],
												[
													14.549,
													16.111
												],
												[
													14.549,
													6.674
												],
												[
													14.549,
													1.73
												],
												[
													8.055,
													-9.027
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-4.155
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.995,
													0
												],
												[
													0.318,
													0.179
												],
												[
													0.001,
													1.129
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.373,
													2.283
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													3.676,
													1.936
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													1.277
												],
												[
													-0.351,
													0
												],
												[
													-0.984,
													-0.554
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-2.05,
													-1.071
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-13.239,
													-19.104
												],
												[
													7.589,
													-8.143
												],
												[
													13.549,
													1.73
												],
												[
													13.549,
													6.674
												],
												[
													13.549,
													16.111
												],
												[
													13.549,
													17.855
												],
												[
													11.48,
													19.924
												],
												[
													10.472,
													19.654
												],
												[
													8.876,
													16.924
												],
												[
													8.875,
													12.623
												],
												[
													8.875,
													12.018
												],
												[
													8.338,
													11.737
												],
												[
													-6.474,
													3.998
												],
												[
													-10.342,
													-1.359
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.949019667682,
											0.941176530427,
											0.89019613827,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"bm": 0,
									"nm": "Fill 1",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											14.799,
											21.174
										]
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"bm": 0,
							"hd": false
						}
					],
					"ip": 0,
					"op": 300,
					"st": 0,
					"bm": 0
				}
			]
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "frammoln/flygande-paket Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 13,
							"s": [
								406.5,
								308,
								0
							],
							"to": [
								-52.834,
								0,
								0
							],
							"ti": [
								94.768,
								0,
								0
							]
						},
						{
							"t": 291,
							"s": [
								34.428,
								308,
								0
							]
						}
					]
				},
				"a": {
					"a": 0,
					"k": [
						13.5,
						9,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						337.037,
						337.037,
						100
					]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ind": 0,
					"ty": "sh",
					"ks": {
						"a": 0,
						"k": {
							"i": [
								[
									0,
									0
								],
								[
									0,
									2.284
								],
								[
									-2.104,
									0.228
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									-1.778,
									0
								],
								[
									-0.434,
									-0.191
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									-2.257,
									0
								],
								[
									-0.242,
									-2.681
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									-2.851
								],
								[
									2.68,
									-0.242
								],
								[
									0,
									0
								]
							],
							"o": [
								[
									-2.283,
									0
								],
								[
									0,
									-2.119
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0.106,
									-1.776
								],
								[
									0.467,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0.688,
									-2.149
								],
								[
									2.693,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									2.875,
									0
								],
								[
									0,
									2.693
								],
								[
									0,
									0
								],
								[
									0,
									0
								]
							],
							"v": [
								[
									4.892,
									16.251
								],
								[
									0.75,
									12.11
								],
								[
									4.441,
									7.995
								],
								[
									4.862,
									7.95
								],
								[
									4.886,
									7.527
								],
								[
									8.244,
									4.359
								],
								[
									9.602,
									4.647
								],
								[
									10.111,
									4.872
								],
								[
									10.281,
									4.343
								],
								[
									15.205,
									0.75
								],
								[
									20.353,
									5.453
								],
								[
									20.394,
									5.908
								],
								[
									20.855,
									5.908
								],
								[
									26.048,
									11.079
								],
								[
									21.347,
									16.227
								],
								[
									21.078,
									16.251
								]
							],
							"c": true
						}
					},
					"nm": "Path 1",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 13,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 67,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 194,
								"s": [
									0
								]
							},
							{
								"t": 291,
								"s": [
									100
								]
							}
						]
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 13,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 67,
								"s": [
									100
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 194,
								"s": [
									100
								]
							},
							{
								"t": 291,
								"s": [
									100
								]
							}
						]
					},
					"o": {
						"a": 0,
						"k": 0
					},
					"m": 1,
					"nm": "Trim Paths 1",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							1,
							1,
							1,
							1
						]
					},
					"o": {
						"a": 0,
						"k": 100
					},
					"w": {
						"a": 0,
						"k": 1
					},
					"lc": 1,
					"lj": 1,
					"ml": 4,
					"bm": 0,
					"nm": "Stroke 1",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							0,
							0.274509803922,
							1,
							1
						]
					},
					"o": {
						"a": 0,
						"k": 100
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"hd": false
				}
			],
			"ip": 13,
			"op": 298,
			"st": 13,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 0,
			"nm": "flaxande 2",
			"refId": "comp_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						226.5,
						186,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						300,
						300,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 600,
			"h": 600,
			"ip": 226,
			"op": 339,
			"st": 226,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 9,
			"ty": 0,
			"nm": "flaxande 2",
			"refId": "comp_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						226.5,
						186,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						300,
						300,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 600,
			"h": 600,
			"ip": 113,
			"op": 226,
			"st": 113,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 10,
			"ty": 0,
			"nm": "flaxande 2",
			"refId": "comp_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						226.5,
						186,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						300,
						300,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 600,
			"h": 600,
			"ip": 0,
			"op": 113,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 11,
			"ty": 4,
			"nm": "bakmoln",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 147,
							"s": [
								350.5,
								328,
								0
							],
							"to": [
								-53.333,
								0,
								0
							],
							"ti": [
								53.333,
								0,
								0
							]
						},
						{
							"t": 362,
							"s": [
								30.5,
								328,
								0
							]
						}
					]
				},
				"a": {
					"a": 0,
					"k": [
						-14.5,
						58,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						337.037,
						337.037,
						100
					]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ind": 0,
					"ty": "sh",
					"ks": {
						"a": 0,
						"k": {
							"i": [
								[
									0,
									0
								],
								[
									0,
									2.284
								],
								[
									-2.104,
									0.228
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									-1.778,
									0
								],
								[
									-0.434,
									-0.191
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									-2.257,
									0
								],
								[
									-0.242,
									-2.681
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									-2.851
								],
								[
									2.68,
									-0.242
								],
								[
									0,
									0
								]
							],
							"o": [
								[
									-2.283,
									0
								],
								[
									0,
									-2.119
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0.106,
									-1.776
								],
								[
									0.467,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0.688,
									-2.149
								],
								[
									2.693,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									2.875,
									0
								],
								[
									0,
									2.693
								],
								[
									0,
									0
								],
								[
									0,
									0
								]
							],
							"v": [
								[
									4.892,
									16.251
								],
								[
									0.75,
									12.11
								],
								[
									4.441,
									7.995
								],
								[
									4.862,
									7.95
								],
								[
									4.886,
									7.527
								],
								[
									8.244,
									4.359
								],
								[
									9.602,
									4.647
								],
								[
									10.111,
									4.872
								],
								[
									10.281,
									4.343
								],
								[
									15.205,
									0.75
								],
								[
									20.353,
									5.453
								],
								[
									20.394,
									5.908
								],
								[
									20.855,
									5.908
								],
								[
									26.048,
									11.079
								],
								[
									21.347,
									16.227
								],
								[
									21.078,
									16.251
								]
							],
							"c": true
						}
					},
					"nm": "Path 1",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 147,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 221,
								"s": [
									0
								]
							},
							{
								"t": 349,
								"s": [
									0
								]
							}
						]
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 147,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 221,
								"s": [
									100
								]
							},
							{
								"t": 349,
								"s": [
									100
								]
							}
						]
					},
					"o": {
						"a": 0,
						"k": 0
					},
					"m": 1,
					"nm": "Trim Paths 1",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							1,
							1,
							1,
							1
						]
					},
					"o": {
						"a": 0,
						"k": 100
					},
					"w": {
						"a": 0,
						"k": 1
					},
					"lc": 1,
					"lj": 1,
					"ml": 4,
					"bm": 0,
					"nm": "Stroke 1",
					"hd": false
				}
			],
			"ip": 147,
			"op": 300,
			"st": 147,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/Flying_box.json
// module id = 47
// module chunks = 0